import styled, { css } from "styled-components";
import theme from "theme";
import { SidebarProps } from "./types";

export const SidebarWrapper = styled.div<SidebarProps>`
    grid-area: sidenav;
    padding: 13px 17px 0px 17px;
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : "256px")};
    min-width: ${({ minWidth }) => (minWidth ? minWidth : "initial")};
    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : "initial")};
    min-height: ${({ minHeight }) => (minHeight ? minHeight : "initial")};
    background: #ffffff;
    box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    position: relative;
    margin: 0 14px;
    ${({ hidden }) =>
        hidden &&
        css`
            display: none;
        `}
    @media (${theme.breakpoints.mobileL}) {
        max-width: 100%;
        border-radius: unset;
        margin: unset;
        margin-top: 5rem;
    }
`;
